import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface QuestionnaireResponseState {
  questionnaireResponses: Record<string, QuestionnaireResponse | undefined>;
}

const initialState: QuestionnaireResponseState = {
  questionnaireResponses: {},
};

export const questionnaireResponseSlice = createSlice({
  name: "questionnaireResponses",
  initialState,
  reducers: {
    setTransferOfCareQuestionnaireResponses: (
      state,
      action: PayloadAction<Record<string, QuestionnaireResponse | undefined>>,
    ) => {
      state.questionnaireResponses = action.payload;
    },
    updateTransferOfCareQuestionnaireResponse: (
      state,
      action: PayloadAction<{
        questionnaireName: string;
        questionnaireResponse: QuestionnaireResponse;
      }>,
    ) => {
      state.questionnaireResponses[action.payload.questionnaireName] =
        action.payload.questionnaireResponse;
    },
  },
});

export const {
  setTransferOfCareQuestionnaireResponses,
  updateTransferOfCareQuestionnaireResponse,
} = questionnaireResponseSlice.actions;

// Selectors
export const selectAllTransferOfCareQuestionnaireResponses = (state: RootState) =>
  state.transferOfCare.questionnaireResponses;

export const selectTransferOfCareQuestionnaireResponseByQuestionnaireName = (
  state: RootState,
  questionnaireName: string,
) => state.transferOfCare.questionnaireResponses[questionnaireName];

export default questionnaireResponseSlice.reducer;
